// CacheKey ab470c2247b0f3f95edcb9bacce6c025
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-ARCH_CARE": {
    data_view: {
      default_name: {
        patients_search: "Members Search"
      },
      headers: {
        defaults: {
          call: {
            patient_name: "Member"
          },
          encounter: {
            case_manager: "Care Manager",
            diagnosis_related_group: "Primary DX Code",
            facility_mrn: "Facility Member ID",
            hospital_service: "Risk Level",
            mrn: "Member ID",
            payor_status: "Plan ID",
            primary_discharge_diagnosis: "Primary DX Description",
            provider_patient_id: "Member ID",
            secondary_discharge_diagnosis: "Secondary DX Description",
            tertiary_discharge_diagnosis: "Secondary DX Code",
            unit_id: "Team Number",
            unit_name: "Team Number"
          },
          patient: {
            health_plan_name: "Plan Name",
            id: "Member ID",
            mrn: "Member ID",
            name: "Member",
            primary_policy_number: "Account Number",
            tags: "Tags"
          },
          stats: {
            patient_errors: "Member Errors",
            patients: "Members"
          },
          unit: {
            name: "Team Number"
          }
        }
      }
    }
  }
}

